import Typography from "@mui/material/Typography";
import styles from "./user.module.scss";
import commonStyles from "../../../App.module.scss";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  styled,
  Card,
  Box,
} from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import Divider from "@mui/material/Divider";
import deleteIcon from "../../../assets/svg/delete_outline.svg";
import FormControl from "@mui/material/FormControl";
import familyIcon from "../../../assets/familymember.svg";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { object, string, ref, ValidationError, number } from "yup";
import dayjs from "dayjs";
import toast, { Toaster } from "react-hot-toast";
import { isNil } from "lodash";
import ToastSuccess from "../toast/toastSuccess";
import ToastError from "../toast/toastError";
import IconButton from "@mui/material/IconButton";
import apiPath from "../../../config/apiPaths.json";
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import constants from "../../../config/constants.json";
import {
  CommonButton,
  CustomMenuItem,
  CustomSelect,
  StyledDateContainer,
  CustomDatePicker,
  CustomCalendarTodayOutlinedIcon,
  CustomInputLabel,
  CustomRequiredInputLabel,
  CustomTextFeild,
  CustomCheckbox,
  ContactNumberInput,
  CommonOutlinedButton,
  CommonOutlinedVerifiedButton,
  CustomCityStateTextField,
} from "../StyledComponents/StyledFields";
import {
  apiRequest,
  catchErrorMessageHandler,
  getUserSelectedRole,
} from "../../../infrastructure/backendService";
import EmptyPage from "../emptyPages/emptyPage";
import {
  registerEventsProps,
  relationListProps,
  specialEventsListProps,
} from "../../../infrastructure/GlobalContextProvider";
import { useNavigate } from "react-router-dom";
import LOCALE from "../../../config/en-us.json";
import CONSTANTS from "../../../config/constants.json";
import CheckIcon from "@mui/icons-material/Check";
import SuccessPopup from "../../devotee/donation/successPopup";
import ErrorPopup from "../ErrorPopup";

interface ErrorMessageTypes {
  firstName: string;
  middleName: string;
  lastName: string;
  dateOfBirth: string;
  weddinganniversary: string;
  preferedlanguage: string;
  nakshatram: string;
  gothram: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
  email: string;
  phoneNumber: string;
  userName: string;
  password: string;
  reenterpassword: string;
  secretQuestion: string;
  answerTosecretQuestion: string;
  confirmAnswerTosecretQuestion: string;
  verificationCode: string;
}
interface Event {
  eventId: any;
  // eventName: string;
  date: string;
  relationId: any;
}

export default function Register() {
  const [showPasswordInfo, setShow] = useState(false);
  const [showSpecialEventsForm, setShowSpecialEventsForm] =
    useState<boolean>(false);
  const [showAddMoreFields, setShowAddMoreFields] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState(false);
  const [specialEventsList, setSpecialEventsList] = useState<
    specialEventsListProps[]
  >([]);
  const [relationList, setRelationList] = useState<any[]>([]);
  const [selectedEvent, setSelectedEvent] = useState<registerEventsProps>({
    eventName: "",
    id: 0,
    isDateDependent: false,
    relation: "",
  });
  const [selectedRelation, setSelectedRelation] = useState<registerEventsProps>(
    {
      eventName: "",
      id: 0,
      isDateDependent: false,
      relation: "",
    }
  );
  const [selectedDate, setSelectedDate] = useState(""); // Updated to Date | null
  const [eventsList, setEventsList] = useState<Event[]>([]);
  const [addedItemsList, setAddedItemsList] = useState<any[]>([]);
  const [showReenterPassword, setReenterpassword] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(true);
  const [selectedId, setSelectedId] = useState<any | null | undefined>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [nakshatramList, setNakshatramList] = useState([]);
  const [showAddMoreButton, setShowAddMoreButton] = useState<boolean>(false);
  const [eventsDisplayList, setEventsDisplayList] = useState<any[]>([]);
  console.log(eventsList, "eventssssssssssssssslist");
  const formFields = {
    firstName: "",
    middleName: "",
    lastName: "",
    dateOfBirth: "",
    weddinganniversary: "",
    preferedlanguage: "",
    nakshatram: "",
    gothram: "",
    address: "",
    city: "",
    state: "",
    zipcode: "",
    country: "",
    email: "",
    phoneNumber: "",
    userName: "",
    password: "",
    reenterpassword: "",
    secretQuestion: "",
    answerTosecretQuestion: "",
    confirmAnswerTosecretQuestion: "",
    verificationCode: "",
  };
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    ...formFields,
  });
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [isDatePickerWedingOpen, setDatePickerWedingOpen] = useState(false);

  const [selectedEventname, setSelectedEventName] = useState("");
  const [selectedEventId, setSelectedEventId] = useState(0);
  const [dateRequired, setDateRequired] = useState(false);
  const [relationName, setRelationName] = useState("");
  const [relationId, setRelationId] = useState(0);
  const [showDateAndRelationFeild, setShowDateAndRelationFeild] =
    useState(true);
  const [showOtpField, setShowOtpField] = useState(false);
  const [registerNowButtonDisable, setRegisterNowButtonDisable] =
    useState(true);
  const [verifiedButton, setVerifiedButton] = useState(false);
  const [emailAndOtpHide, setEmailAndOtpHide] = useState(false);

  const handleDatePickerClick = () => {
    setDatePickerOpen(true);
  };

  const handleDatePickerWedingClick = () => {
    setDatePickerWedingOpen(true);
  };
  const navigate = useNavigate();
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const hasManagerLevelRole = constants.showDashBoardForRoles.includes(
    getUserSelectedRole() || ""
  );

  const handleClickShowRenterPassword = () =>
    setReenterpassword((show) => !show);
  const handleMouseDownReenterPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@`#^_$!%*?&])[A-Za-z\d@`#^_$!%*?&]{9,16}$/;
  const validationSchema = object().shape({
    firstName: string().required("First Name is required"),
    lastName: string().required("Last Name is required"),
    dateOfBirth: string().required("DOB is required"),
    email: string()
      .required("Email is required")
      .matches(emailRegex, "Please enter valid email address")
      .min(6, "Email must be at least 6 characters")
      .max(64, "Email cannot exceed 64 characters"),
    country: string().required("Country is required"),
    city: string().required("city is required"),
    state: string().required("state is required"),
    zipcode: number().required("zipcode is required"),
    phoneNumber: string()
      .required("Phone Number is required")
      .matches(/^\d{10}$/, "Phone Number should be 10 digits"),
    userName: string().required("User Name is required"),
    password: string()
      .min(9, "Password must be at least 9 characters")
      .max(16, "Password must be no more than 16 characters")
      .required("Password is required")
      .test(
        "password-complexity",
        "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
        (value) => {
          const uppercaseRegex = /[A-Z]/;
          const lowercaseRegex = /[a-z]/;
          const numberRegex = /[0-9]/;
          const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;

          let errors = [];

          if (!uppercaseRegex.test(value)) {
            errors.push("uppercase letter");
          }
          if (!lowercaseRegex.test(value)) {
            errors.push("lowercase letter");
          }
          if (!numberRegex.test(value)) {
            errors.push("number");
          }
          if (!specialCharRegex.test(value)) {
            errors.push("special character");
          }

          if (errors.length > 0) {
            return new ValidationError(
              `Password must contain at least one ${errors.join(", ")}.`,
              null,
              "password"
            );
          }

          return true;
        }
      ),
    reenterpassword: string()
      .required("Re-enter Password is required")
      .oneOf([ref("password")], "Passwords must match"),
  });

  const columnMapping: Record<string, string> = {
    Event: "Event",
    Date: "Date",
    Email: "Email",
    Relation: "Relation",
    Action: "Action",
  };

  const [specialEventsData, setSpecialEventsData] = useState<any[]>([]);

  const [languageItems, setLanguageItems] = useState<any[]>([]);

  const [formData, setFormData] = useState({ ...formFields, country: "USA" });

  const handleShowForm = () => {
    setShowSpecialEventsForm(true);
  };

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.registerSubscribableEvents,
      // includeToken: true,
    })
      .then((res) => {
        setSpecialEventsList(res.data);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.languages,
      // includeToken: true,
    })
      .then((res) => {
        setLanguageItems(res.data.content);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.nakshatramListApi,
      // includeToken: true,
    })
      .then((res) => {
        setNakshatramList(res.data.content);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.relationsList,
      params: {
        sortBy: "id",
        page: 0,
        size: 100,
        direction: "asc",
      },
      // includeToken: true,
    })
      .then((res) => {
        setRelationList(res.data.content);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  useEffect(() => {
    setDatePickerOpen(false);
  }, [formData.dateOfBirth]);

  useEffect(() => {
    setDatePickerWedingOpen(false);
  }, [formData.weddinganniversary]);

  const handleCancel = () => {
    window.scrollTo(0, 0);
    setFormData(formFields);
  };

  const handleFieldChange = (field: string, value: any) => {
    if (field === "dateOfBirth" || field === "weddinganniversary") {
      const formattedDate = dayjs(value, "MM-DD-YYYY");
      setDatePickerOpen(false);

      setFormData({
        ...formData,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM-DD-YYYY")
          : "",
      });
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
    setDatePickerOpen(false);
  };

  const handleClose = () => {
    setIsOpen(false);
    setSelectedId(null);
  };
  const handleAgree = () => {
    if (selectedId !== null) {
      // Find the index of the item with the selected ID in the addedItemsList
      const indexToRemove = eventsDisplayList.findIndex(
        (item) => item.eventId === selectedId
      );
      const indexToRemoved = eventsList.findIndex(
        (item) => item.eventId === selectedId
      );

      if (indexToRemove !== -1) {
        // Create a copy of the addedItemsList without the selected item
        const updatedList = [...eventsDisplayList];
        updatedList.splice(indexToRemove, 1);

        // Update the addedItemsList and recalculate the total donation amount
        // setEventsList(updatedList);
        setEventsDisplayList(updatedList);
      }
      if (indexToRemoved !== -1) {
        // Create a copy of the addedItemsList without the selected item
        const updatedList = [...eventsList];
        updatedList.splice(indexToRemove, 1);

        // Update the addedItemsList and recalculate the total donation amount
        setEventsList(updatedList);
        // setEventsDisplayList(updatedList);
      }
    }
    // Close the dialog
    handleClose();
  };

  const dialogPopup = () => {
    return (
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            height: "calc(100% - 128px)",
            width: "calc(100% - 128px)",
            margin: "64px",
            maxWidth: "504px",
            maxHeight: "180px",
            overflowY: "unset",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        <DialogTitle className={commonStyles.dialogTitle}>
          {"Please Confirm"}

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 24,
              top: 12,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className={commonStyles.dialogContext}
          >
            Are You Sure want to remove the Item ?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <CommonOutlinedButton onClick={handleClose}>No</CommonOutlinedButton>
          <CommonButton onClick={handleAgree}>Yes</CommonButton>
        </DialogActions>
      </Dialog>
    );
  };

  const nakshatramDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropdownStyle} sx={{ width: "100%" }}>
        <CustomSelect
          id="nakshatram"
          IconComponent={KeyboardArrowDownIcon}
          // id="grouped-select"
          placeholder="Select Nakshatram"
          value={formData.nakshatram}
          onChange={(e) => {
            setErrorMessage({ ...errorMessage, nakshatram: "" });
            handleFieldChange("nakshatram", e.target.value);
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={errorMessage.nakshatram ? styles.errorTextField : ""}
        >
          {nakshatramList.map((item: any, index: number) => (
            <CustomMenuItem key={index} value={item.nakshatramName}>
              {item.nakshatramName}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.nakshatram ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.nakshatram}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const prefferedLanguageDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropdownStyle} sx={{ width: "100%" }}>
        <CustomSelect
          id="prefferedLanguages"
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          // id="grouped-select"
          value={formData.preferedlanguage}
          onChange={(e) =>
            handleFieldChange("preferedlanguage", e.target.value)
          }
          className={errorMessage.preferedlanguage ? styles.errorTextField : ""}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {languageItems.map((item: any, index: number) => (
            <CustomMenuItem key={index} value={item.name}>
              {item.name}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.preferedlanguage && (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.preferedlanguage}
          </Typography>
        )}
      </FormControl>
    );
  };

  const handleSave = async (): Promise<void> => {
    const errors: ErrorMessageTypes = { ...formFields };

    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // alert('Registration Successful');
      // Call your API or perform other actions here
      saveApiCall();
    } catch (error: any) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e: any) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  let emailInputLabel;
  if (!hasManagerLevelRole) {
    emailInputLabel = CustomRequiredInputLabel("Email", true);
  } else {
    emailInputLabel = CustomRequiredInputLabel("Email", false);
  }

  let phoneNumberInputLabel;
  if (!hasManagerLevelRole) {
    phoneNumberInputLabel = CustomRequiredInputLabel("Contact No", true);
  } else {
    phoneNumberInputLabel = CustomRequiredInputLabel("Contact No", false);
  }

  const verification = () => {
    if (!hasManagerLevelRole) {
      return formData.verificationCode;
    } else {
      return null;
    }
  };

  const saveApiCall = () => {
    const reqBody = {
      firstname: formData.firstName,
      middleName: formData.middleName,
      lastname: formData.lastName,
      dateOfBirth: formData.dateOfBirth,
      weddingAnniversary: formData.weddinganniversary,
      preferredLanguage: formData.preferedlanguage,
      phoneResidence: formData.phoneNumber,
      nakshatram: formData.nakshatram,
      gothram: formData.gothram,
      address: formData.address,
      city: formData.city,
      state: formData.state,
      zipcode: formData.zipcode,
      country: formData.country,
      phoneWork: formData.phoneNumber,
      email: formData.email,
      username: formData.userName,
      password: formData.password,
      hintQuestion: formData.secretQuestion,
      hintAnswer: formData.answerTosecretQuestion,
      eventsSubscribed: eventsList,
      verificationCode: verification(),
      // dateOfRegistration : "",
      // relation:'',
      // updateDate : "",
    };
    apiRequest({
      method: "POST",
      endpoint: apiPath.registerDevoteeApi,
      body: JSON.stringify(reqBody),
    })
      .then((res) => {
        const successMessage = LOCALE.USER_REGISTER_SUCCESS;
        toast.custom(
          <SuccessPopup
            headerMessage="Registration"
            showMessage={successMessage}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />
        );
        setFormData(formFields);
        navigate("/");
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: CONSTANTS.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const emailVerificationApiCall = () => {
    if (formData.email === "" || errorMessage.email !== "") {
      setErrorMessage({ ...errorMessage, email: "Please Enter Valid Email." });
    } else {
      apiRequest({
        method: "POST",
        endpoint: `${apiPath.emailVerificationApi}/${formData.email}/`,
        params: {
          firstname: formData.firstName,
          lastname: formData.lastName,
        },
      })
        .then((res) => {
          const successMessage = LOCALE.OTP_SENT_TO_MAIL;
          // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
          //   duration: 10000,
          // });
          toast.custom(
            <SuccessPopup
              headerMessage="OTP Verification"
              showMessage={successMessage}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
          setShowOtpField(true);
        })
        .catch((err) => {
          toast.custom(
            <ErrorPopup
              showMessage={catchErrorMessageHandler(err)}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        });
    }
  };

  const emailVerificationCodeApiCall = () => {
    if (formData.verificationCode === "") {
      setErrorMessage({
        ...errorMessage,
        verificationCode: "Please Enter OTP.",
      });
    } else {
      apiRequest({
        method: "POST",
        endpoint: `${apiPath.emailVerificationCodeApi}/${formData.email}/verificationCode/${formData.verificationCode}`,
      })
        .then((res) => {
          const successMessage = LOCALE.OTP_VERIFICATION_SUCCESS;
          // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
          //   duration: 10000,
          // });
          toast.custom(
            <SuccessPopup
              headerMessage="OTP Verification"
              showMessage={successMessage}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
          setRegisterNowButtonDisable(false);
          setVerifiedButton(true);
          setEmailAndOtpHide(true);
          setShowOtpField(false);
        })
        .catch((err) => {
          toast.custom(
            <ErrorPopup
              showMessage={catchErrorMessageHandler(err)}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        });
    }
  };

  const userNameCheckAPI = () => {
    if (!formData.userName) {
      setErrorMessage({
        ...errorMessage,
        userName: "",
      });
      return;
    }
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.userNameCheckApi}/${formData.userName}`,
      // includeToken: true,
    })
      .then((res) => {
        const userNameExist = res.data.usernameExists;
        if (userNameExist === true) {
          setErrorMessage({
            ...errorMessage,
            userName: res.data.Message,
          });
        } else {
          setErrorMessage({
            ...errorMessage,
            userName: "",
          });
        }
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleKeyPress = (e:any) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent the default form submission behavior
      handleSave();
    }
  };

  const handleButtons = () => {
    return (
      <div style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}>
        <CommonOutlinedButton onClick={handleCancel} id="cancel">
          Cancel
        </CommonOutlinedButton>
        {!hasManagerLevelRole ? (
          <CommonButton
            onClick={handleSave}
            disabled={registerNowButtonDisable}
            id="registerNow"
          >
            Register Now
          </CommonButton>
        ) : (
          <Box>
            <CommonButton onClick={handleSave} >Register Now</CommonButton>
          </Box>
        )}
      </div>
    );
  };

  const emptyPageButton = (): React.ReactElement => {
    return (
      <div>
        <CommonButton
          className={styles.addfamilyButton}
          onClick={handleAddMore}
          id="addMore"
        >
          Add More
        </CommonButton>
      </div>
    );
  };

  const BasicDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer id="dob"
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
          onClick={handleDatePickerClick}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDatePickerOpen}
                onClose={() => setDatePickerOpen(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD"
                value={
                  formData.dateOfBirth
                    ? dayjs(formData.dateOfBirth, "MM-DD")
                    : ""
                }
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, dateOfBirth: "" });
                  handleFieldChange("dateOfBirth", value);
                  setDatePickerOpen(false);
                }}
                disableFuture
                className={
                  errorMessage.dateOfBirth
                    ? styles.errorDateFeild
                    : styles.dateFeild
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.dateOfBirth ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.dateOfBirth}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const WeddingDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer
          id="weddingAnniversary"
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
            border: " 1px solid rgba(136, 46, 20, 0.4)",
          }}
          onClick={handleDatePickerWedingClick}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDatePickerWedingOpen}
                onClose={() => setDatePickerWedingOpen(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD"
                value={
                  formData.weddinganniversary
                    ? dayjs(formData.weddinganniversary, "MM-DD")
                    : ""
                }
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, weddinganniversary: "" });
                  handleFieldChange("weddinganniversary", value);
                }}
                className={
                  errorMessage.weddinganniversary
                    ? commonStyles.errorTextField
                    : commonStyles.textField
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.weddinganniversary ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.weddinganniversary}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const handleChangeEvent = (e: any) => {
    setSelectedEventName(e.target.value);
    const selectedEvents = specialEventsList.find(
      (event: specialEventsListProps) => event.eventName === e.target.value
    );
    if (selectedEvents) {
      console.log(
        selectedEvents,
        selectedDate,
        selectedRelation,
        "selectedEvent"
      );
      if (selectedEvents.isDateDependent && selectedDate && selectedRelation) {
        setButtonDisable(false);
      } else if (!selectedEvents.isDateDependent) {
        setButtonDisable(false);
      }
      setSelectedEventId(selectedEvents.id);
      setDateRequired(selectedEvents.isDateDependent);
      setSelectedEventName(selectedEvents.eventName);
      if (!selectedEvents.isDateDependent) {
        setShowDateAndRelationFeild(false);
      } else {
        setShowDateAndRelationFeild(true);
      }
    }
  };
  const handleChangeRelation = (e: any) => {
    // setSelectedRelation(e.target.value);
    const selectedRelations = relationList.find(
      (relation: relationListProps) => relation.name === e.target.value
    );

    if (selectedRelations) {
      selectedDate && setButtonDisable(false);
      setRelationId(selectedRelations.id);
      setRelationName(selectedRelations.name);
    }
  };

  const handleChangeDate = (value: any) => {
    const formattedDate = dayjs(value, "MM-DD-YYYY");
    if (relationName) {
      setButtonDisable(false);
    }
    setSelectedDate(
      formattedDate.isValid() ? formattedDate.format("MM-DD-YYYY") : ""
    );
  };

  const handleAddDetails = () => {
    if (selectedEventname) {
      const newEventObject = {
        // eventName: selectedEventname,
        eventId: selectedEventId,
        date: dateRequired ? selectedDate : "",
        relationId: dateRequired ? relationId : 0,
      };
      console.log(selectedEvent, "newEventObjectnewEventObject");

      const displayEventsList = {
        eventName: selectedEventname,
        eventId: selectedEventId,
        date: dateRequired ? selectedDate : "",
        relation: dateRequired ? relationName : "",
      };

      // Add new event data to the lists
      setEventsList([...eventsList, newEventObject]);
      setSpecialEventsData([...specialEventsData, newEventObject]);
      setEventsDisplayList([...eventsDisplayList, displayEventsList]);
      // Clear the fields
      setSelectedEventName("");
      setSelectedEventId(0);
      setSelectedDate("");
      setRelationName("");

      // Update state to manage UI
      setShowAddMoreFields(false);
      setShowAddMoreButton(true);
      setButtonDisable(false);
    }
    setButtonDisable(true);
  };

  const [datePickerClickSpecialEvent, setDatePickerClickSpecialEvent] =
    useState(false);
  const handleDatePickerClickSpecialEvent = () => {
    setDatePickerClickSpecialEvent(true);
  };
  useEffect(() => {
    setDatePickerClickSpecialEvent(false);
  }, [selectedDate]);

  const EventDatePicker = (): React.ReactElement => {
    return (
      <div
        style={{
          width: "100%",
          border: "1px solid rgba(136, 46, 20, 0.40)",
          borderRadius: "8px",
        }}
      >
        <StyledDateContainer
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
          onClick={handleDatePickerClickSpecialEvent}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={datePickerClickSpecialEvent}
                onClose={() => setDatePickerClickSpecialEvent(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={selectedDate ? dayjs(selectedDate, "MM-DD-YYYY") : ""}
                onChange={(value) => {
                  handleChangeDate(value);
                }}
                className={styles.dateFeild}
              />
            </DemoContainer>
          </LocalizationProvider>
          {/* {errorMessage.dateOfBirth ? (
                  <Typography sx={{ color: 'red', fontSize: '12px' }}>
                     {errorMessage.dateOfBirth}
                  </Typography>
               ) : (
                  ''
               )} */}
        </StyledDateContainer>
      </div>
    );
  };

  const SpecialEventsDropdown = (): React.ReactElement => {
    return (
      <FormControl
        sx={{
          width: "100%",
          border: "1px solid rgba(136, 46, 20, 0.40)",
          borderRadius: "8px",
        }}
      >
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="grouped-select"
          onChange={handleChangeEvent}
          value={selectedEventname}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {specialEventsList.map((item: specialEventsListProps, i: number) => (
            <CustomMenuItem value={item.eventName} key={i}>
              {item.eventName}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const RelationDropdown = (): React.ReactElement => {
    return (
      <FormControl
        sx={{
          width: "100%",
          border: "1px solid rgba(136, 46, 20, 0.40)",
          borderRadius: "8px",
        }}
      >
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="grouped-select"
          onChange={handleChangeRelation}
          value={relationName}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {relationList.map((item: relationListProps, i: any) => (
            <CustomMenuItem value={item.name} key={i}>
              {item.name}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const handleAddMore = () => {
    setShowAddMoreFields(true);
    setShowAddMoreButton(false);
  };

  const specialEvents = () => {
    return (
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid xs={12} sm={3} item>
          <CustomInputLabel>Events</CustomInputLabel>
          {SpecialEventsDropdown()}
        </Grid>
        {showDateAndRelationFeild ? (
          <>
            <Grid xs={12} sm={3} item>
              <CustomInputLabel>Date</CustomInputLabel>
              {EventDatePicker()}
            </Grid>
            <Grid xs={12} sm={3} item>
              <CustomInputLabel>Relation</CustomInputLabel>
              {RelationDropdown()}
            </Grid>
          </>
        ) : (
          ""
        )}
        <CommonButton
          sx={{ marginTop: "43px", marginLeft: "20px" }}
          onClick={handleAddDetails}
          disabled={buttonDisable}
        >
          Add
        </CommonButton>
      </Grid>
    );
  };

  const zipCodeApi = () => {
    if (formData.zipcode === "") {
      setErrorMessage({
        ...errorMessage,
        zipcode: "Please Enter Zipcode",
      });
    } else {
      apiRequest({
        method: "GET",
        endpoint: apiPath.cityAndStateApi,
        params: {
          zip: formData.zipcode,
        },
      })
        .then((res) => {
          setFormData({
            ...formData,
            state: res.data.stateName,
            city: res.data.city,
          });
        })
        .catch((err) => {
          setErrorMessage({
            ...errorMessage,
            zipcode: catchErrorMessageHandler(err),
          });
          setFormData({
            ...formData,
            state: "",
            city: "",
          });
        });
    }
  };
  const openConfirmPopUp = (id: number | undefined | null) => {
    setSelectedId(id);
    setIsOpen(true);
  };

  const tableDataComponent = (): JSX.Element => {
    return (
      <div className={styles.table}>
        {/* <Typography className={styles.listHeading}>
          List of Item Added
        </Typography> */}
        {eventsDisplayList.length > 0 ? (
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Event Name</th>
                <th className={styles.tableHorizontal}>Date</th>
                <th className={styles.tableHorizontal}>Relation</th>
                <th className={styles.tableHorizontal}>Action</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody} id="specialEvents">
              {eventsDisplayList.map((item: any, index: number) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.tableDiagonal}>{item.eventName}</td>
                  <td className={styles.tableDiagonal}>{item.date}</td>
                  <td className={styles.tableDiagonal}>{item.relation}</td>
                  <td className={styles.tableDiagonal}>
                    <img
                      src={deleteIcon}
                      onClick={() => openConfirmPopUp(item?.eventId)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <EmptyPage imgUrl={familyIcon} subComponent={emptyPageButton()} />
        )}
      </div>
    );
  };
  const handleKeyDown = (e: any, fieldName: string) => {
    // Prevent entering numeric characters, spaces, and specific special characters
    if (
      (e.key >= "0" && e.key <= "9") ||
      e.key === " " || // prevent spaces
      /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-=`|"\s]/.test(e.key) // prevent specific special characters and whitespace
    ) {
      e.preventDefault();
    }
  };
  const handleKeyDownuser = (e: any, fieldName: string) => {
    if (!/[0-9a-zA-Z_]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const validatePasswordLength = (password: string) => {
    const maxLength = 12;

    if (password.length > maxLength) {
      return `Password must be between  6 to ${maxLength} characters.`;
    }
  };

  const validateEmail = () => {
    const { email } = formData;

    if (email.length < 6) {
      setErrorMessage({
        ...errorMessage,
        email: "Email must be at least 6 characters long.",
      });
    } else if (email.length >= 64) {
      setErrorMessage({
        ...errorMessage,
        email: "Email must be less than 64 characters long.",
      });
    } else if (!email.includes("@") || !email.includes(".")) {
      setErrorMessage({
        ...errorMessage,
        email: "Please Enter Valid Email",
      });
    } else {
      setErrorMessage({ ...errorMessage, email: "" });
    }
  };

  return (
    <div className={styles.BoxContainer}>
      <Typography component="div" className={styles.typoGraphyHeading}>
        Register
      </Typography>
      <form className={styles.formContainer} onKeyDown={handleKeyPress}>
        <Typography component="div" className={styles.typoGraphy}>
          Basic Information
        </Typography>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid xs={12} sm={3} item>
            {CustomRequiredInputLabel("First Name", true)}
            <CustomTextFeild
              id="firstName"
              fullWidth
              required
              value={formData.firstName}
              onChange={(e: any) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 50) {
                  setErrorMessage({ ...errorMessage, firstName: "" });
                  handleFieldChange("firstName", inputValue);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    firstName: "Maximum allowed characters is 50.",
                  });
                }
              }}
              onKeyDown={(e) => handleKeyDown(e, "firstName")}
              className={
                errorMessage.firstName
                  ? styles.errorTextField
                  : styles.textField
              }
              placeholder="Enter Firstname"
            />
            {errorMessage.firstName && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.firstName}
              </Typography>
            )}
          </Grid>

          <Grid xs={12} sm={3} item>
            <CustomInputLabel>Middle Name</CustomInputLabel>
            <CustomTextFeild
              id="middleName"
              fullWidth
              required
              value={formData.middleName}
              onChange={(e: any) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 50) {
                  setErrorMessage({ ...errorMessage, middleName: "" });
                  handleFieldChange("middleName", inputValue);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    middleName: "Maximum allowed characters is 50.",
                  });
                }
              }}
              onKeyDown={(e) => handleKeyDown(e, "middleName")}
              className={
                errorMessage.middleName
                  ? styles.errorTextField
                  : styles.textField
              }
              placeholder="Enter Middlename"
            />
            {errorMessage.middleName && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.middleName}
              </Typography>
            )}
          </Grid>
          <Grid xs={12} sm={3} item>
            {CustomRequiredInputLabel("Last Name", true)}
            <CustomTextFeild
              id="lastName"
              fullWidth
              required
              value={formData.lastName}
              onChange={(e: any) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 50) {
                  setErrorMessage({ ...errorMessage, lastName: "" });
                  handleFieldChange("lastName", inputValue);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    lastName: "Maximum allowed characters is 50.",
                  });
                }
              }}
              onKeyDown={(e) => handleKeyDown(e, "lastName")}
              className={
                errorMessage.lastName ? styles.errorTextField : styles.textField
              }
              placeholder="Enter Lastname"
            />
            {errorMessage.lastName && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.lastName}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("DOB", true)}
            {BasicDatePicker()}
          </Grid>
          <Grid item xs={12} sm={3}>
            <CustomInputLabel>Wedding Anniversary</CustomInputLabel>
            {WeddingDatePicker()}
          </Grid>
          <Grid item xs={12} sm={3}>
            <CustomInputLabel>Preferred Language</CustomInputLabel>
            {prefferedLanguageDropdown()}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid item xs={12} sm={3}>
            <CustomInputLabel>Nakshatram</CustomInputLabel>
            {nakshatramDropdown()}
          </Grid>
          <Grid item xs={12} sm={3}>
            <CustomInputLabel>Gothram</CustomInputLabel>
            <CustomTextFeild
              id="gothram"
              sx={{
                border: "1px solid rgba(136, 46, 20, 0.40)",
                borderRadius: "8px",
              }}
              fullWidth
              required
              value={formData.gothram}
              onChange={(e: any) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 25) {
                  setErrorMessage({ ...errorMessage, gothram: "" });
                  handleFieldChange("gothram", inputValue);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    gothram: "Gothram cannot exceed 25 characters",
                  });
                }
              }}
              className={
                errorMessage.gothram ? styles.errorTextField : styles.textField
              }
              placeholder="Enter Gothram"
            />
            {errorMessage.gothram && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.gothram}
              </Typography>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
            sx={{ display: "flex", alignItems: "center", marginTop: "25px" }}
          >
            <CustomCheckbox disabled={true} />
            <CustomInputLabel id="chandrama">Chandramana</CustomInputLabel>
            <CustomCheckbox disabled={true} />
            <CustomInputLabel id="sourama">Souramana</CustomInputLabel>
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: "100%",
            background: "#C1C1C1",
            height: "1px",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        />

        <Typography component="div" className={styles.typoGraphy}>
          Contact Info
        </Typography>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("Zip Code", true)}
            <CustomTextFeild
              id="zipCode"
              fullWidth
              required
              value={formData.zipcode}
              onChange={(e) => {
                const inputValue = e.target.value;
                // Only allow numbers
                const sanitizedInput = inputValue
                  .replace(/[^0-9]/g, "")
                  .slice(0, 10);
                setErrorMessage({ ...errorMessage, zipcode: "" });
                handleFieldChange("zipcode", sanitizedInput);
              }}
              onBlur={zipCodeApi}
              className={
                errorMessage.zipcode ? styles.errorTextField : styles.textField
              }
              placeholder="Enter Zipcode"
            />
            {errorMessage.zipcode ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.zipcode}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("City", true)}
            <CustomCityStateTextField
              id="city"
              fullWidth
              required
              value={formData.city}
              InputProps={{
                readOnly: true,
              }}
              onChange={(e) => {
                setErrorMessage({ ...errorMessage, city: "" });
                handleFieldChange("city", e.target.value);
              }}
              className={
                errorMessage.city ? styles.errorTextField : styles.textField
              }
            />
            {errorMessage.city ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.city}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("State", true)}
            <CustomCityStateTextField
              id="state"
              fullWidth
              required
              value={formData.state}
              InputProps={{
                readOnly: true,
              }}
              onChange={(e) => {
                setErrorMessage({ ...errorMessage, state: "" });
                handleFieldChange("state", e.target.value);
              }}
              className={
                errorMessage.state ? styles.errorTextField : styles.textField
              }
            />
            {errorMessage.state ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.state}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("Country", true)}
            <CustomTextFeild
              id="country"
              fullWidth
              required
              value={formData.country}
              onChange={(e) => {
                setErrorMessage({ ...errorMessage, country: "" });
                handleFieldChange("country", e.target.value);
              }}
              className={
                errorMessage.country ? styles.errorTextField : styles.textField
              }
            />
            {errorMessage.country ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.country}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("Address", false)}
            <CustomTextFeild
              id="address"
              fullWidth
              required
              value={formData.address}
              onChange={(e: any) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 100) {
                  setErrorMessage({ ...errorMessage, address: "" });
                  handleFieldChange("address", inputValue);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    address: "Address cannot exceed 100 characters",
                  });
                }
              }}
              className={
                errorMessage.address ? styles.errorTextField : styles.textField
              }
              placeholder="Enter Address"
            />
            {errorMessage.address ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.address}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("Contact No", true)}
            <CustomTextFeild
              id="phoneNumber"
              fullWidth
              required
              value={formData.phoneNumber}
              onChange={(e) => {
                const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
                setErrorMessage({ ...errorMessage, phoneNumber: "" });
                handleFieldChange("phoneNumber", slicedNumber);
              }}
              className={
                errorMessage.phoneNumber
                  ? styles.errorTextField
                  : styles.textField
              }
              placeholder="Enter Phonenumber"
            />
            {errorMessage.phoneNumber ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.phoneNumber}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("Email", true)}
            <CustomTextFeild
              id="email"
              fullWidth
              required
              value={formData.email}
              InputProps={{
                readOnly: emailAndOtpHide,
              }}
              onChange={(e) => {
                setErrorMessage({ ...errorMessage, email: "" });
                handleFieldChange("email", e.target.value);
              }}
              onBlur={validateEmail}
              className={
                errorMessage.email ? styles.errorTextField : styles.textField
              }
              placeholder="Enter Email"
            />
            {errorMessage.email ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.email}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: "100%",
            background: "#C1C1C1",
            height: "1px",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        />

        <Typography component="div" className={styles.typoGraphy}>
          Login Info
        </Typography>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("User Name", true)}
            <CustomTextFeild
              id="userName"
              fullWidth
              required
              value={formData.userName}
              placeholder="Enter Username"
              onChange={(e) => {
                const inputUserName = e.target.value;
                if (inputUserName.length <= 10 && !/\s/.test(inputUserName)) {
                  setErrorMessage({ ...errorMessage, userName: "" });
                  handleFieldChange("userName", inputUserName);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    userName: "Username must be 4 to 10 characters.",
                  });
                }
              }}
              onBlur={() => {
                // Convert the username to uppercase using the current state value
                let inputUserName = formData.userName.toUpperCase();
                handleFieldChange("userName", inputUserName);
                userNameCheckAPI();

                // Check the length when the input field loses focus
                if (inputUserName.length < 4) {
                  setErrorMessage({
                    ...errorMessage,
                    userName: "Username must be at least 4 characters.",
                  });
                }
              }}
              onKeyDown={(e) => handleKeyDownuser(e, "userName")}
              error={Boolean(errorMessage.userName)}
              className={
                errorMessage.userName ? styles.errorTextField : styles.textField
              }
            />

            {errorMessage.userName ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.userName}
              </Typography>
            ) : (
              ""
            )}
          </Grid>

          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("Password", true)}
            <CustomTextFeild
              id="password"
              fullWidth
              required
              type={showPassword ? "text" : "password"}
              value={formData.password}
              onChange={(e) => {
                const newPassword = e.target.value;
                handleFieldChange("password", newPassword);
                setErrorMessage({ ...errorMessage, password: "" });
              }}
              error={Boolean(errorMessage.userName)}
              className={
                errorMessage.password ? styles.errorTextField : styles.textField
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" sx={{ margin: 0 }}>
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                      sx={{
                        background: "#FFF9E4",
                        borderRadius: "1%",
                        padding: "11px",
                        "&:hover": {
                          background: "#FFF9E4",
                          borderRadius: "1%",
                          padding: "11px",
                        },
                      }}
                    >
                      {showPassword ? (
                        <VisibilityOutlinedIcon />
                      ) : (
                        <VisibilityOffOutlinedIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              placeholder="Enter Password"
            />
            {errorMessage.password ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.password}
              </Typography>
            ) : (
              ""
            )}
            {/* <p style={{fontSize: "12px", color: "#686868"}}>Min 9 and max 16 chars, at least 1 uppercase, 1 lowercase, 1 number and 1 special character</p> */}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("Re-enter Password", true)}
            <CustomTextFeild
              id="reEnterPassword"
              fullWidth={true}
              required={true}
              type={showReenterPassword ? "text" : "password"}
              value={formData.reenterpassword}
              onChange={(e) => {
                setErrorMessage({ ...errorMessage, reenterpassword: "" });
                handleFieldChange("reenterpassword", e.target.value);
              }}
              className={
                errorMessage.reenterpassword
                  ? styles.errorTextField
                  : styles.textField
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" sx={{ margin: 0 }}>
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowRenterPassword}
                      onMouseDown={handleMouseDownReenterPassword}
                      edge="end"
                      sx={{
                        background: "#FFF9E4",
                        borderRadius: "1%",
                        padding: "11px",
                        "&:hover": {
                          background: "#FFF9E4",
                          borderRadius: "1%",
                          padding: "11px",
                        },
                      }}
                    >
                      {showReenterPassword ? (
                        <VisibilityOutlinedIcon />
                      ) : (
                        <VisibilityOffOutlinedIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              placeholder="Re-enter Password"
            />
            {errorMessage.reenterpassword ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.reenterpassword}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            <Card className={commonStyles.passwordHints}>
              <ul id="note">
                <li>{LOCALE.PASSWORD_HINT_ONE}</li>
                <li>{LOCALE.PASSWORD_HINT_TWO}</li>
              </ul>
            </Card>
          </Grid>
        </Grid>

        {!hasManagerLevelRole && (
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            {showOtpField ? (
              <Grid item xs={12} sm={3}>
                {CustomRequiredInputLabel("OTP", false)}
                <CustomTextFeild
                  id="otp"
                  fullWidth
                  required
                  value={formData.verificationCode}
                  InputProps={{
                    readOnly: emailAndOtpHide,
                  }}
                  onChange={(e) => {
                    setErrorMessage({ ...errorMessage, verificationCode: "" });
                    handleFieldChange("verificationCode", e.target.value);
                  }}
                  className={
                    errorMessage.verificationCode
                      ? styles.errorTextField
                      : styles.textField
                  }
                  placeholder="Enter OTP"
                />
                {errorMessage.verificationCode ? (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errorMessage.verificationCode}
                  </Typography>
                ) : (
                  ""
                )}
                {verifiedButton ? (
                  <div
                    style={{ marginTop: "10px", display: "flex", gap: "1rem" }}
                  >
                    <CommonOutlinedVerifiedButton
                      endIcon={<CheckIcon />}
                      id="checkIcon-verified"
                    >
                      Verified
                    </CommonOutlinedVerifiedButton>
                  </div>
                ) : (
                  <div
                    style={{ marginTop: "10px", display: "flex", gap: "1rem" }}
                  >
                    <CommonButton
                      onClick={emailVerificationCodeApiCall}
                      id="verify"
                    >
                      Verify
                    </CommonButton>
                    <CommonOutlinedButton
                      onClick={emailVerificationApiCall}
                      id="resend"
                    >
                      Resend
                    </CommonOutlinedButton>
                  </div>
                )}
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sm={3}
                sx={{ marginTop: "10px", gap: "1rem", display: "flex" }}
              >
                <CommonButton
                  onClick={emailVerificationApiCall}
                  disabled={emailAndOtpHide}
                  id="emailVerification"
                >
                  Email Verification
                </CommonButton>
              </Grid>
            )}
          </Grid>
        )}
      </form>
      <Typography
        sx={{ marginTop: "20px", marginBottom: "20px" }}
        component="div"
        className={styles.typoGraphy}
      >
        Special Events
      </Typography>
      <div className={styles.familyDetails}>
        {specialEventsData.length === 0 ? (
          !showSpecialEventsForm ? (
            <EmptyPage imgUrl={familyIcon} subComponent={emptyPageButton()} />
          ) : null
        ) : (
          tableDataComponent()
        )}
      </div>
      {showAddMoreFields ? specialEvents() : ""}
      {specialEventsData.length !== 0 ? (
        showAddMoreButton ? (
          <CommonButton sx={{ marginTop: "10px" }} onClick={handleAddMore}>
            Add More
          </CommonButton>
        ) : null
      ) : (
        ""
      )}
      <div className={styles.handlebuttoncontainer}>
        {/* <ToastComponent /> */}
        <Toaster />
        {handleButtons()}
        {dialogPopup()}
      </div>
    </div>
  );
}
